<template>
  <div v-if="post && post.details" class="post-grid-card">

    <div class="card-header">
      <div class="asset-container">
        <img v-if="post.details.featuredImage" :src="post.details.featuredImage" alt="post featured image"/>

        <img v-else src="../../../assets/defaultPostImage.png" alt="Default Post Image"/>
      </div>
    </div>

    <div class="card-content">
      <post-info :post="post"/>
      <div class="main-content">
        <div class="title heading-3-bold">{{ post.details.title }}</div>
        <div class="short-description paragraph-1">{{ post.details.description }}</div>
      </div>
    </div>

    <div class="button-container">
      <seu-button
        :button-link="postLink.link"
        :target="postLink.target"
        :route="postLink.route"
        :label="$t('common.read_more')"

      />
      <div >
        <blog-social-links
          :post="post"
        />
<!--        <seu-button-->
<!--          v-if="!shareActive"-->
<!--          class="share-button"-->
<!--          :label="$t('common.share')"-->
<!--          :button-icon-before="shareIcon"-->
<!--          @click="shareActive = true"-->
<!--        />-->

<!--        <div v-else class="share-icons-button">-->
<!--          <a href="">-->
<!--            <img src="../../../assets/icons/square-linkedin.svg" alt="">-->
<!--          </a>-->
<!--          <a href="">-->
<!--            <img src="../../../assets/icons/square-twitter.svg" alt="">-->
<!--          </a>-->
<!--          <a href="">-->
<!--            <img src="../../../assets/icons/square-facebook.svg" alt="">-->
<!--          </a>-->
<!--&lt;!&ndash;          <a href="">&ndash;&gt;-->
<!--&lt;!&ndash;            <img src="../../../assets/icons/square-instagram.svg" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;          </a>&ndash;&gt;-->
<!--          <a href="">-->
<!--            <img src="../../../assets/icons/link.svg" alt="">-->
<!--          </a>-->
<!--        </div>-->
      </div>
    </div>

  </div>

</template>
<script>
import ViButton from "seu-frontend/components/common/ViButton.vue"
import PostInfo from "./PostInfo";
import SeuButton from "/seu-frontend/components/SeuButton";
import BlogSocialLinks from "/seu-frontend/modules/blog/components/BlogSocialLinks";

export default {
  name: "PostGridCard",
  components: {BlogSocialLinks, SeuButton, PostInfo, ViButton},
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    postLink() {
      if (this.post.details.externalLink) {
        return {
          link: this.post.details.externalLink,
          target: '_blank'
        }
      } else {

        return {
          route: {
            name: "PostDetailsPage",
            params: {
              slug: this.post.details.slug,
              lang: this.$route.params.lang
            }
          },
          target: '_self'
        }
      }
    }
  },
  methods: {
    openPostDetails() {
      this.$bubbleUp('viewPost', this.post)
    }
  },
  data: () => ({
    shareIcon: require('../../../assets/icons/share-icon.svg'),
    shareActive: false
  })
}
</script>
<style lang="scss">
@import "PostGridCard";
</style>
